import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import utilStyle from "./Utils.module.css";
import { Save } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import pageStyle from "./CustomerDetails.module.css";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { APICustomer, getAllCustomers, getCustomer } from "../api/customers";

import {
  APIAppointment,
  emptyAppointment,
  getAppointment,
  saveAppointment,
} from "../api/appointments";

function AppointmentDetailsPage({ id }: { id?: string }) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const cid = searchParams.get("cid");

  const [appointment, setAppointment] = useState<APIAppointment>(
    emptyAppointment()
  );
  const [customersData, setCustomersData] = useState<APICustomer[]>([]);

  useEffect(() => {
    getAllCustomers().then((v) => setCustomersData(v));
  }, []);

  useEffect(() => {
    getAppointment(id || undefined, cid || undefined).then((v) =>
      setAppointment(v)
    );
  }, [id, cid]);

  const updateAppointment = async (update: Partial<APIAppointment>) => {
    if (update.startTime) {
      update.endTime = update.startTime + 1000 * 60 * 60 * 2; // set end time to 2 hours after by default
    }
    const updated = { ...appointment, ...update };
    setAppointment(updated);
    save(updated);
  };

  const save = async (updatedAppointment: APIAppointment) => {
    let a = await saveAppointment(updatedAppointment);
    if (!appointment.id) {
      navigate(`/appointments?id=${a.id}`);
    }
  };

  return (
    <div className={pageStyle.customerDetailPanel}>
      <form className={pageStyle.editCustomerForm}>
        <FormControl>
          <InputLabel>Customer</InputLabel>
          <Select
            value={appointment.customerId}
            onChange={(e) => updateAppointment({ customerId: e.target.value })}
            label="Customer"
          >
            {customersData.map((c) => (
              <MenuItem key={c.id} value={c.id}>
                {c.firstName} {c.lastName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              onChange={(e) =>
                updateAppointment({
                  startTime: e ? e.unix() * 1000 : undefined,
                })
              }
              value={
                appointment.startTime ? dayjs(appointment.startTime) : undefined
              }
              label="Start Time"
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl fullWidth>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              onChange={(e) =>
                updateAppointment({
                  endTime: e ? e.unix() * 1000 : undefined,
                })
              }
              value={
                appointment.endTime ? dayjs(appointment.endTime) : undefined
              }
              label="End Time"
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl>
          <InputLabel htmlFor="notesInput">Notes</InputLabel>
          <OutlinedInput
            value={appointment.notes}
            onChange={(e) => updateAppointment({ notes: e.target.value })}
            multiline
            minRows={3}
            id="notesInput"
            label="Notes"
          />
        </FormControl>
      </form>
    </div>
  );
}

export default AppointmentDetailsPage;
